<template>
<div>
<h2 v-if="!hide">{{title}}</h2>
<slot />
<br/>
<hr v-if="!last"/>
</div>
</template>
<script setup lang="ts">
defineProps<{
  title?: string
  last?: boolean
  hide?: boolean
}>()
</script>